import { authService } from '@/services/authService'
import { Button } from '@/common/components/button/Button'
import { useEffect } from 'react'
/**
 * 본인인증 체크 페이지 컴포넌트
 */

interface Props { 
  $width?: 'fit-content' | 'full';
  $height?: number;
  $variant?: 'destructive' | 'outline' | 'ghost' | 'gradient' | 'fill' | 'outline-destructive';
  $size?: 'xxs' | 'xs' | 'sm' | 'lg' | 'md';
  $title?: string;
  onSuccess: (data: InisisAuthResult) => void
}

export interface InisisAuthResult {
  isDuplicate: boolean,
  userDi: string,
  userCi: string,
  userName: string,
  userPhone: string,
  userBirth: string,
  userGender: string,
  token: string
}

const InisisAuthButton = ({ onSuccess, $variant, $size, $title = '간편인증' }: Props) => {
  /**
   * 인증 요청 처리 함수
   * @param data 인증 요청 데이터
   */
  const handleSubmit = (data: any) => {
    console.log('인증 요청 시작', data)

    // 팝업 창 설정
    const width = 400
    const height = 640
    const left = window.innerWidth / 2 - width / 2 + window.screenLeft

    // 팝업 창 열기
    const popup = window.open(
      '',
      'sa_popup',
      `width=${width}, height=${height}, left=${left}, menubar=yes, status=yes, titlebar=yes, resizable=yes`
    )

    if (popup) {
      // 폼 생성 및 설정
      const form = document.createElement('form')
      form.setAttribute('target', 'sa_popup')
      form.setAttribute('method', 'POST')
      form.setAttribute('action', 'https://sa.inicis.com/id/auth')

      // 폼 데이터 추가
      Object.entries(data).forEach(([key, value]) => {
        const input = document.createElement('input')
        input.setAttribute('type', 'hidden')
        input.setAttribute('name', key)
        input.setAttribute('value', value as string)
        form.appendChild(input)
      })

      // 폼 제출
      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
    } else {
      alert('팝업이 차단되었습니다. 팝업 차단을 해제해주세요.')
    }
  }

  const handleMessage = (event: MessageEvent) => {

    if (event.data && event.data.source !== "inisis_auth_result") {
      return;
    }

    console.log('message', event);
    onSuccess(event.data.data);
  }

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    }
  }, [])

  return (
      <Button 
        $variant={$variant}
        $size={$size}
        onClick={async () => {
          const response = await authService.inisisRequest()
          console.log(response)
          handleSubmit(response)
        }}
      >
        {$title}
      </Button>
  )
}

export default InisisAuthButton